import { useState } from "react";
import { styled } from '@mui/material/styles';
import React from 'react';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import { Grid } from "@mui/material";
import HTMLReactParser from "html-react-parser";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AccordionPanelStyled = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '20px !important',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionPanelSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ExpandCircleDownOutlinedIcon sx={{ fontSize: '1.5rem', color: "white" }} />}
        {...props}
    />
))(({ theme }) => ({
    color: "#1e456c",
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionPanelDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
}));

interface Props {
    id?: string;
    children: React.ReactNode;
    header?: string;
    SubHeader?: any;
    props?: AccordionSummaryProps;
    onClick?: any;
    isExpanded?: boolean; //false = เปิด หรือ true = ปิด ไว้
    className?: any;
    onChange?: (expand: boolean) => void;

    color?: string;
    expandIconColor?: string;
    bgColor?: string;
    background?: string;
    borderColor?: string;
    borderRadius?: string;
    boxShadowHead?: string;
    boxShadowDetail?: string;
    SubHeaderStatus?: any;
    sStyleSubHeader?: string;
    isDisabled?: boolean;
}

const AccordionPanel: React.FC<Props> = ({ 
    id, 
    children, 
    header, 
    props, 
    isExpanded, 
    SubHeader,
    className, 
    onChange,
    
    color, 
    expandIconColor, 
    bgColor, 
    background, 
    borderColor, 
    borderRadius, 
    boxShadowHead, 
    boxShadowDetail,
    SubHeaderStatus,
    sStyleSubHeader,
    isDisabled = false,
}) => {

    const [expanded, setExpanded] = useState<string | false>(isDisabled === true ? false : (isExpanded === true ? SubHeader ? 'panel1' : false : 'panel1'));
    const [action, setAction] = useState(SubHeader != null ? true : false);
    
    const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        if (isDisabled !== true) 
        {
            let isExpand = newExpanded ? panel : false;
            setExpanded(isExpand);
            if (SubHeader) {
                setTimeout(() => {
                    setAction(!action);
                    setExpanded('panel1');
                }, 300)
            }
            if(onChange)onChange(newExpanded);
        }
    };

    return (
        <Grid item xs={12} md={12}>
            <AccordionPanelStyled
                {...props}
                id={id}
                data-testid={id}
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
                className={className}
                sx={{ border: borderColor }}
            >
                <AccordionPanelSummary
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                    className={expanded === 'panel1' ? "panel1" : ""}
                    sx={{
                        zIndex: 'auto',
                        color: color ?? "#ffffff",
                        backgroundColor: bgColor ?? "#5a4011",
                        background: (isDisabled === true ? "#8c8c8c" : (background ?? "#5a4011")),
                        cursor: 'pointer',
                        borderRadius: borderRadius ?? "18px !important",
                        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                            transform: 'rotate(180deg)',
                        },
                        '& .MuiAccordionSummary-content': {
                            marginLeft: '8px',
                        },
                        alignItems: SubHeader ? "start" : "center",
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            margin: SubHeader ? "12px 0" : "0"
                        },
                        boxShadow: boxShadowHead ?? "none",
                    }}
                >
                    <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center">
                        <Grid item xs={12} md={12} container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item xs={10} md={(sStyleSubHeader != null ? 'auto' : (SubHeaderStatus != null ? 8 : 12))}>
                                <Typography className="font-medium">{HTMLReactParser(header)}</Typography>
                            </Grid>                        
                            {SubHeaderStatus != null && 
                                <Grid item xs={2} md={4} container spacing={1} justifyContent={sStyleSubHeader ? sStyleSubHeader : "end"} alignItems="center" style={{ paddingTop: '2%', }}>
                                    {SubHeaderStatus}                            
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </AccordionPanelSummary>
                {action === true ?
                    <AccordionPanelDetails sx={{
                        boxShadow: boxShadowDetail ?? "none",
                        borderRadius: borderRadius ?? "0px"
                    }}>
                        {SubHeader}
                    </AccordionPanelDetails>
                    :
                    <AccordionPanelDetails sx={{
                        boxShadow: boxShadowDetail ?? "none",
                        borderRadius: borderRadius ?? "0px"
                    }}>
                        {children}
                    </AccordionPanelDetails>
                }
            </AccordionPanelStyled>
        </Grid>
    )
}

export default AccordionPanel